import lodashHas from "lodash/has";
import { httpDelete, httpGet, httpPost, httpPut } from "@/services/api.service";
import { ENDPOINT_MY_INCIDENTS } from "@/common/constants/api";
import {
  MY_INCIDENTS_CUSTOM_ICONS,
  MY_INCIDENTS_ICONS,
} from "@/common/constants/myIncidents";

export { _getMyIncidents as getMyIncidents };
export { _loadMapIcons as loadMapIcons };
export { _getProfile as getProfile };
export { _updateProfile as updateProfile };
export { _saveMyIncident as saveMyIncident };
export { _deleteMyIncident as deleteMyIncident };

const _getMyIncidents = async (params) => {
  try {
    const {
      page,
      itemsPerPage,
      sortBy,
      sortDirection,
      search,
      startDate,
      endDate,
    } = params.options;
    const url = new URL(ENDPOINT_MY_INCIDENTS);

    const sort = sortBy?.map(
      (item, index) => `${item}:${sortDirection[index]}`
    );

    if (!!page) {
      url.searchParams.append("page", page);
    }
    if (!!itemsPerPage) {
      url.searchParams.append("pageSize", itemsPerPage);
    }
    if (!!sortBy) {
      url.searchParams.append("sort", sort.join(","));
    }
    if (!!search) {
      url.searchParams.append("search", search);
    }
    if (!!startDate) {
      url.searchParams.append("startDate", startDate);
    }
    if (!!endDate) {
      url.searchParams.append("endDate", endDate);
    }

    const response = await httpGet({
      url: url.toString(),
    });
    const parsedResponse = JSON.parse(response);
    if (lodashHas(parsedResponse, "data.incidents")) {
      return parsedResponse.data;
    }
    return {
      incidents: undefined,
      metadata: {
        pageNumber: undefined,
      },
    };
  } catch (error) {
    console.error("Error retrieving my incidents: ", error);
    return false;
  }
};

const _loadIcon = (map, id, src) => {
  map.loadImage(src, (err, image) => {
    if (err) {
      console.error(err);
    } else {
      map.addImage(id, image);
    }
  });
};

const _loadSvg = (map, id, src) => {
  const img = new Image(40, 40);
  img.onload = () => map.addImage(id, img);
  img.onerror = (err) => console.error(err);
  img.src = src;
};

const _loadMapIcons = (map) => {
  [...MY_INCIDENTS_ICONS, ...MY_INCIDENTS_CUSTOM_ICONS]
    .filter((icon) => !map.hasImage(`myincidents_${icon.value}`))
    .forEach((icon) => {
      try {
        _loadIcon(
          map,
          `myincidents_${icon.value}`,
          require(`@/assets/images/icons/${icon.fileName}`)
        );
      } catch (error) {
        console.error(error);
      }
    });
};

// Update Customer profile options
const _updateProfile = async (profile) => {
  try {
    const res = await httpPut({
      url: ENDPOINT_MY_INCIDENTS + "/profile",
      data: profile,
      giveFailedResponse: true,
    });
    return true;
  } catch (error) {
    console.error("Unable to update customer profile", error);
    throw error;
  }
};

const _getProfile = async () => {
  try {
    let res = await httpGet({
      url: ENDPOINT_MY_INCIDENTS + "/profile",
      giveFailedResponse: true,
    });
    const { data } = JSON.parse(res);
    return data?.profile;
  } catch (error) {
    console.error("Unable to get customer profile by user group", error);
    return undefined;
  }
};

const _saveMyIncident = async (incident) => {
  try {
    if (!incident.id) {
      await httpPost({
        url: ENDPOINT_MY_INCIDENTS,
        data: incident,
        giveFailedResponse: true,
      });
      return true;
    } else {
      await httpPut({
        url: `${ENDPOINT_MY_INCIDENTS}/${incident.id}`,
        data: incident,
        giveFailedResponse: true,
      });
      return true;
    }
  } catch (error) {
    console.error("Unable to save incident", error);
    return false;
  }
};

const _deleteMyIncident = async (id) => {
  try {
    await httpDelete({
      url: `${ENDPOINT_MY_INCIDENTS}/${id}`,
      giveFailedResponse: true,
    });
    return true;
  } catch (error) {
    console.error("Unable to delete incident", error);
    return false;
  }
};
